$(document).ready(function(){
  if($('body').hasClass('template-index')){
    //scrollAnimation();
  }
});

function scrollAnimation() {
  $(window).scroll(function() {
      var wS = $(this).scrollTop();
      var vertivalDistance = $('.homepage-section--shop-the-look-wrapper').offset().top; //Fait attention - peut-etre change

      if (wS <= (vertivalDistance-700)) {
        console.log('test-1');
        $('.flexslider.flexslider-homepage .flex-active-slide .slider-description-outer .slider-description-inner').css('--translateX','1100px');
      }else if (wS <= (vertivalDistance-600)) {
        console.log('test-2');
        $('.flexslider.flexslider-homepage .flex-active-slide .slider-description-outer .slider-description-inner').css('--translateX','500px');
      }else if (wS <= (vertivalDistance-400)) {
        console.log('test-3');
        $('.flexslider.flexslider-homepage .flex-active-slide .slider-description-outer .slider-description-inner').css('--translateX','0px');
      }else if (wS <= (vertivalDistance-200)) {
        console.log('test-4');
        $('.flexslider.flexslider-homepage .flex-active-slide .slider-description-outer .slider-description-inner').css('--translateX','-500px');
      }else if (wS <= (vertivalDistance-100)) {
        console.log('test-5');
        $('.flexslider.flexslider-homepage .flex-active-slide .slider-description-outer .slider-description-inner').css('--translateX','-1100px');
      }
  });
}